<template>
    <div class="container pt-3">
        <div class="row justify-content-lg-center">
            <div class="col-lg-12" style="font-size: 0.8rem">
                <div class="d-flex justify-content-between align-items-center" style="height: 37.79px; margin-bottom: 20px">
                    <div class="d-flex align-items-baseline" style="gap: 10px">
                        <h1 class="h1-title" style="font-weight: 500 !important; line-height: 21px">{{ $t('views.transactions.title') }}</h1>
                    </div>
                    <div class="d-flex align-items-center sm-flex-column">
                        <div class="date-picker-wrapper">
                            <DateRangePicker :callback="handleDate" :singleDatePicker="false" :dateData="date_range" openPosition="left" :language="$i18n.locale" />
                        </div>
                    </div>
                </div>
                <div class="store-tabs">
                    <a href="#" @click.prevent="navigateTo('summary')" class="store-tabs__item" :class="{ active: activeTab === 'summary' }">
                        <span>{{ $t('views.transactions.tabs.summary') }}</span>
                    </a>
                    <a href="#" @click.prevent="navigateTo('expenses')" class="store-tabs__item" :class="{ active: activeTab === 'expenses' }">
                        <span>{{ $t('views.transactions.tabs.expenses') }}</span>
                    </a>
                    <a href="#" @click.prevent="navigateTo('incomes')" class="store-tabs__item" :class="{ active: activeTab === 'incomes' }">
                        <span>{{ $t('views.transactions.tabs.incomes') }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="action-header">
            <div class="d-flex justify-content-between align-items-center sm-flex-column">
                <div class="d-flex sm-flex-column">
                    <div class="d-flex">
                        <div class="d-flex flex-column justify-content-center" style="border-right: 0.6px solid #e7eaf3; margin-right: 8px; padding-right: 15px; color: #677788">
                            <strong>{{ activeTab === 'summary' ? getTransactionTotal : activeTab === 'incomes' ? incomes.total : expenses.total }}</strong>
                            <span>{{ $t('views.transactions.result') }}</span>
                        </div>
                        <div class="mr-8">
                            <select v-model="perPage" class="form-select form-select-sm">
                                <option v-for="i in [10, 25, 50, 100]" :key="i" :value="i">{{ i }} {{ $t('views.transactions.perPage') }}</option>
                            </select>
                        </div>
                        <div class="mr-8">
                            <select v-model="currentPage" class="form-select form-select-sm">
                                <option v-for="n in totalPages" :key="n" :value="n">{{ n }}. {{ $t('views.transactions.page') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="search-form">
                        <input
                            v-model="searchQuery"
                            class="form-control form-control-sm"
                            type="text"
                            :placeholder="$t('views.transactions.search')"
                            style="font-size: 13px; height: 37.5px; min-width: 310px !important"
                            @keyup.enter="search"
                            @input="search"
                        />
                        <button class="btn btn-sm btn-link" style="height: 37.5px; line-height: 1; position: absolute; top: -2px; right: 0" @click="search">
                            <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                    </div>
                    <div class="ms-3 position-relative">
                        <div class="dropdown" ref="categoryFilterDropdown">
                            <input
                                v-model="categoryFilterInput"
                                @focus="showCategoryFilterOptions = true"
                                @click="showCategoryFilterOptions = true"
                                @input="onCategoryFilterSearch"
                                type="text"
                                class="form-control form-control-sm"
                                :placeholder="$t('views.transactions.filters.categoryFilter') || 'Kategori Filtresi'"
                                style="height: 37.5px; font-size: 13px; min-width: 200px"
                            />
                            <div v-if="showCategoryFilterOptions" class="dropdown-menu show">
                                <div v-if="categoriesLoading" class="dropdown-item text-center">
                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                        <span class="visually-hidden">Yükleniyor...</span>
                                    </div>
                                </div>
                                <a class="dropdown-item" href="#" @click.prevent="selectCategoryFilter('')">
                                    {{ $t('views.transactions.filters.allCategories') || 'Tüm Kategoriler' }}
                                </a>
                                <a v-if="filteredCategoryOptions.length === 0 && !categoriesLoading" class="dropdown-item text-muted" href="#"> Sonuç bulunamadı </a>
                                <a v-else v-for="category in filteredCategoryOptions" :key="category" @click.prevent="selectCategoryFilter(category)" class="dropdown-item" href="#">
                                    {{ category }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- Frequency (Tür) filtresi - sadece expenses tab'ında göster -->
                    <div v-if="activeTab === 'expenses'" class="ms-3">
                        <select v-model="frequencyFilter" class="form-select form-select-sm" style="height: 37.5px; font-size: 13px; min-width: 120px">
                            <option value="">{{ $t('views.transactions.filters.frequencyFilter') || 'Tür Filtresi' }}</option>
                            <option value="ONCE">{{ $t('views.transactions.frequency.once') || 'Bir Kere' }}</option>
                            <option value="DAILY">{{ $t('views.transactions.frequency.daily') || 'Günlük' }}</option>
                            <option value="WEEKLY">{{ $t('views.transactions.frequency.weekly') || 'Haftalık' }}</option>
                            <option value="MONTHLY">{{ $t('views.transactions.frequency.monthly') || 'Aylık' }}</option>
                            <option value="QUARTERLY">{{ $t('views.transactions.frequency.quarterly') || 'Üç Aylık' }}</option>
                            <option value="HALF_YEARLY">{{ $t('views.transactions.frequency.halfYearly') || 'Altı Aylık' }}</option>
                            <option value="YEARLY">{{ $t('views.transactions.frequency.yearly') || 'Yıllık' }}</option>
                        </select>
                    </div>
                </div>
                <div class="d-flex">
                    <button v-if="activeTab !== 'summary'" class="btn btn-sm btn-secondary" @click="addNewTransaction"><i class="fa fa-plus me-1"></i> {{ $t('views.transactions.actions.addNew') }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-content container">
        <div v-if="activeTab === 'summary'">
            <TransactionsSummary />
        </div>
        <div v-if="activeTab === 'expenses'">
            <TransactionsExpenses ref="expensesComponent" />
        </div>
        <div v-if="activeTab === 'incomes'">
            <TransactionsIncomes ref="incomesComponent" />
        </div>
    </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker.vue'
import TransactionsExpenses from '@/components/Transactions/TransactionsExpenses.vue'
import TransactionsIncomes from '@/components/Transactions/TransactionsIncomes.vue'
import TransactionsSummary from '@/components/Transactions/TransactionsSummary.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

moment.utc()

export default {
    name: 'TransactionsView',
    components: {
        TransactionsSummary,
        TransactionsExpenses,
        TransactionsIncomes,
        DateRangePicker,
    },
    data() {
        return {
            activeTab: 'summary',
            isFilterVisible: false,
            availableCategories: [], // Kategorilerin listesi
            showCategoryFilterOptions: false,
            categoryFilterInput: '',
            categoriesLoading: false,
            filteredCategoryOptions: [],
            categorySearchTimeout: null, // Kategori filtreleme için debounce timeout ID
            searchTimeout: null, // Arama için debounce timeout ID
            showDateRangePicker: false, // Tarih seçicisinin görünürlüğünü kontrol eden flag
            isDateRangeSelected: false, // Kullanıcının bir tarih aralığı seçip seçmediğini belirtir
            date_range: {
                startDate: new Date(new Date().getFullYear(), 0, 1), // Bu yılın başlangıcı
                endDate: new Date(new Date().getFullYear(), 11, 31), // Bu yılın sonu
            },
            daysShortcuts: ['today', 'thisWeek', 'thisMonth', 'pastMonth', 'thisYear'],
            currentShortcut: 'thisYear',
        }
    },
    computed: {
        ...mapState('transactions', {
            filterParams: (state) => state.filterParams,
            incomes: (state) => state.incomes,
            expenses: (state) => state.expenses,
        }),
        sessionDateRange() {
            return sessionStorage.getItem('dateRangeTransaction')
        },
        searchQuery: {
            get() {
                return this.filterParams.search
            },
            set(value) {
                this.updateFilterParams({ key: 'search', value, fetchData: false })
            },
        },
        categoryFilter: {
            get() {
                return this.filterParams.categoryFilter
            },
            set(value) {
                this.updateFilterParams({ key: 'categoryFilter', value, fetchData: false })
            },
        },
        frequencyFilter: {
            get() {
                return this.filterParams.frequencyFilter
            },
            set(value) {
                this.updateFilterParams({ key: 'frequencyFilter', value, fetchData: false })
            },
        },
        perPage: {
            get() {
                return this.filterParams.perPage
            },
            set(value) {
                this.updateFilterParams({ key: 'perPage', value, fetchData: false })
            },
        },
        currentPage: {
            get() {
                return this.filterParams.page
            },
            set(value) {
                this.updateFilterParams({ key: 'page', value, fetchData: false })
            },
        },
        totalPages() {
            // Aktif tab'a göre sayfa sayısını hesapla
            if (this.activeTab === 'summary') {
                const summaryTotal = this.$store.state.transactions.summary.data?.total || 0
                return Math.ceil(summaryTotal / this.filterParams.perPage) || 1
            }

            const type = this.activeTab === 'incomes' ? 'income' : 'expense'
            const list = type === 'income' ? this.incomes : this.expenses
            return Math.ceil(list.total / this.filterParams.perPage) || 1
        },
        getTransactionTotal() {
            // Özet sayfası için işlem toplam sayısını al
            if (this.$store.state.transactions.summary.data && this.$store.state.transactions.summary.data.total) {
                return this.$store.state.transactions.summary.data.total
            }
            return this.incomes.total + this.expenses.total
        },
        lastUpdate() {
            // Aktif tab'a göre son güncelleme zamanını al
            if (this.activeTab === 'summary') {
                return this.$store.state.transactions.summary.lastUpdate
            } else if (this.activeTab === 'incomes') {
                return this.incomes.lastUpdate
            }
            return this.expenses.lastUpdate
        },
        formattedLastUpdate() {
            if (!this.lastUpdate) return ''
            return moment(this.lastUpdate).format('DD.MM.YYYY HH:mm:ss')
        },
        filteredAvailableCategories() {
            // Tüm kategorileri göster, sadece listeleme sırasında Amazon varsa onu çıkar
            // çünkü Amazon zaten en üstte statik olarak gösteriliyor
            return this.availableCategories.filter((category) => category !== 'Amazon')
        },
    },
    created() {
        // URL'den tab parametresini al
        this.setTabFromRoute()

        this.date = this.sessionDateRange ? [this.sessionDateRange.split(',')[0], this.sessionDateRange.split(',')[1]] : [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]

        // Kayıtlı sütun ayarlarını yükle
        const savedColumns = localStorage.getItem('columns.transactions')
        if (savedColumns) {
            this.setColumns(JSON.parse(savedColumns))
        }

        // Kategorileri yükle
        this.loadCategories()

        // Search inputlarını resetle
        this.resetSearch()

        // Sayfa ilk yüklendiğinde filtreleri hazırla ama veri çekme işlemini tetikleme
        this.updateFilterParams({
            key: 'dateRange',
            value: {
                startDate: moment(this.date_range.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.date_range.endDate).format('YYYY-MM-DD'),
            },
            fetchData: false,
        })

        // İlk yüklemede aktif tab'a göre doğru API çağrısını yapalım
        this.pageLoad()

        // Dropdown'ın dışına tıklandığında kapanması için event listener ekleyelim
        document.addEventListener('click', this.handleOutsideClick)
    },
    beforeUnmount() {
        // Component yok olduğunda event listener'ı kaldıralım
        document.removeEventListener('click', this.handleOutsideClick)

        // Timeout'ları temizle
        if (this.categorySearchTimeout) {
            clearTimeout(this.categorySearchTimeout)
        }
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
    },
    methods: {
        ...mapActions('transactions', ['getTransactions', 'getTransactionsSummary', 'updateFilterParams', 'setColumns', 'getCategories']),
        setDateRangShort(startDate, endDate) {
            this.date_range = {
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
            }
            this.showDateRangePicker = true // Tarih seçildiğinde görünür olsun
            this.isDateRangeSelected = true // Kullanıcı bir tarih aralığı seçti

            // Aktif tab'a göre uygun veri tipini çek
            // this.fetchDataByActiveTab()
        },
        navigateTo(tab) {
            // Eğer zaten aynı tab ise işlem yapma
            if (this.activeTab === tab) return

            // Tab değerini güncelle
            this.activeTab = tab

            // URL'i güncelle ama sayfa yeniden yüklenmesini önlemek için replace kullan
            this.$router
                .replace({
                    name: 'transactions-type',
                    params: { type: tab },
                })
                .catch(() => {})

            // Tüm filtreleri ve search inputlarını temizle
            this.resetSearch()

            // Tab'a uygun veri tipini ayarla ve verileri yükle
            if (tab === 'incomes') {
                // Store'da tip parametresini güncelle, veri çekme işlemini otomatik tetikleme
                this.updateFilterParams({ key: 'type', value: 'income', fetchData: false })
                this.getTransactions('income')
            } else if (tab === 'expenses') {
                // Store'da tip parametresini güncelle, veri çekme işlemini otomatik tetikleme
                this.updateFilterParams({ key: 'type', value: 'expense', fetchData: false })
                this.getTransactions('expense')
            } else if (tab === 'summary') {
                // Özet verilerini yükle
                this.getTransactionsSummary()
            }

            // Tab değiştikten sonra kategorileri yeniden yükle
            this.loadCategories()

            console.log('Tab changed to:', tab)
        },
        changeDateShortcut(day) {
            const today = moment().startOf('day').toDate()
            this.currentShortcut = day

            switch (day) {
                case 'today':
                    this.setDateRangShort(today, today)
                    break
                case 'thisWeek':
                    this.setDateRangShort(moment().subtract(6, 'days').toDate(), today)
                    break
                case 'thisMonth':
                    this.setDateRangShort(moment().startOf('month').toDate(), today)
                    break
                case 'pastMonth':
                    this.setDateRangShort(moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate())

                    break
                case 'thisYear':
                    this.setDateRangShort(new Date(new Date().getFullYear(), 0, 1), today)
                    break
            }
        },
        setTabFromRoute() {
            // URL'den tab parametresini alıyoruz (route.params.type)
            const typeParam = this.$route.params.type

            // URL'den gelen parametreyi kontrol ediyoruz
            if (typeParam && ['summary', 'expenses', 'incomes'].includes(typeParam)) {
                this.activeTab = typeParam
                console.log('URL parametresi ile tab ayarlandı:', typeParam)
            } else {
                // Eğer URL'de belirtilmemişse, varsayılan olarak 'summary' tab'ını göster
                this.activeTab = 'summary'
                console.log('Varsayılan tab ayarlandı: summary')
            }

            // Search inputlarını resetle
            this.resetSearch()
        },
        // Kategori listesini yükle
        async loadCategories() {
            // Aktif sekmeye göre type parametresini ayarla
            let activeType
            if (this.activeTab === 'summary') {
                activeType = 'summary'
            } else {
                activeType = this.activeTab === 'incomes' ? 'income' : 'expense'
            }

            try {
                // İlk yüklemede tüm kategorileri getir
                const result = await this.getCategories({
                    type: activeType,
                    search: '',
                    all: true,
                })

                if (result && result.data) {
                    // Benzersiz kategori listesini al
                    const categories = result.data.map((item) => item.category_name).filter(Boolean)
                    // Alfabetik sırala
                    this.availableCategories = [...new Set(categories)].sort()

                    // Sayfa ilk yüklendiğinde filteredCategoryOptions listesini doldur
                    // İlk yüklemede en fazla 10 kategoriyi göster
                    this.filteredCategoryOptions = [...this.availableCategories].slice(0, 10)
                }
            } catch (error) {
                console.error('Kategoriler yüklenirken hata oluştu:', error)
            }
        },
        updateCategoriesFromTransactions(type) {
            // API'den tüm kategorileri yükle, mevcut işlemlerden gelen kategorileri kullanma
            //  this.loadCategories()
        },
        search() {
            // Search timeout'u temizle
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }

            // Store'daki arama parametresini güncelle, veri çekme işlemini otomatik tetikleme
            this.updateFilterParams({ key: 'search', value: this.searchQuery, fetchData: false })

            // 300ms bekleyip sonra veri çekme işlemini başlat
            this.searchTimeout = setTimeout(() => {
                // Manuel olarak veri çekme işlemini başlat
                this.fetchDataByActiveTab()
                console.log('Searching for:', this.searchQuery)
            }, 300)
        },
        handleDate(data) {
            this.isDateRangeSelected = true // Kullanıcı bir tarih aralığı seçti

            // Store'a tarih aralığını ekle, fetchData=true ile verilerin otomatik yüklenmesini sağla
            this.updateFilterParams({
                key: 'dateRange',
                value: {
                    startDate: moment(data.startDate).format('YYYY-MM-DD'),
                    endDate: moment(data.endDate).format('YYYY-MM-DD'),
                },
                fetchData: false,
            })

            // Tarih seçiciyi görünür yap
            this.showDateRangePicker = true

            // Aktif tab'a göre uygun veri tipini çek
            this.fetchDataByActiveTab()

            console.log('Date range changed:', this.filterParams.dateRange)
        },
        addNewTransaction() {
            if (this.activeTab === 'expenses') {
                if (this.$refs.expensesComponent) {
                    this.$refs.expensesComponent.startAddNew()
                }
            } else if (this.activeTab === 'incomes') {
                if (this.$refs.incomesComponent) {
                    this.$refs.incomesComponent.startAddNew()
                }
            } else {
                // Summary tabında ise kullanıcıya önce bir tür seçtirmeliyiz
                // Basit bir uyarı gösterelim
                alert(this.$t('views.transactions.selectTabFirst'))
            }
        },
        async onCategoryFilterSearch() {
            // Kategori filtresi arama işlemi
            this.categoriesLoading = true
            try {
                // Aktif sekmeye göre type parametresini ayarla
                let activeType
                if (this.activeTab === 'summary') {
                    activeType = 'summary'
                } else {
                    activeType = this.activeTab === 'incomes' ? 'income' : 'expense'
                }

                const result = await this.getCategories({
                    type: activeType,
                    search: this.categoryFilterInput,
                    all: true,
                })

                if (result && result.data) {
                    // Benzersiz kategori listesini al
                    const categories = result.data.map((item) => item.category_name).filter(Boolean)

                    // Benzersiz kategorileri al ve listele (en fazla 10 tane)
                    this.filteredCategoryOptions = [...new Set(categories)].filter((category) => category.toLowerCase().includes(this.categoryFilterInput.toLowerCase())).slice(0, 10)
                }
            } catch (error) {
                console.error('Kategoriler aranırken hata oluştu:', error)
            } finally {
                this.categoriesLoading = false
            }
        },
        selectCategoryFilter(category) {
            this.categoryFilter = category
            this.categoryFilterInput = category
            this.showCategoryFilterOptions = false
        },
        handleOutsideClick(event) {
            // Kategori filtresi dropdown'u dışına tıklandığında kapat
            if (this.$refs.categoryFilterDropdown && !this.$refs.categoryFilterDropdown.contains(event.target)) {
                this.showCategoryFilterOptions = false
            }
        },
        activateDatePicker() {
            this.showDateRangePicker = true
            // Veri çekmiyoruz, sadece datepicker'ı gösteriyoruz
        },
        // Aktif taba göre veri çeken yardımcı metod
        fetchDataByActiveTab() {
            if (this.activeTab === 'incomes') {
                this.getTransactions('income')
            } else if (this.activeTab === 'expenses') {
                this.getTransactions('expense')
            } else {
                this.getTransactionsSummary()
            }
        },
        resetSearch() {
            // Search, kategori ve frequency inputlarını sıfırla
            this.updateFilterParams({ key: 'search', value: '', fetchData: false })
            this.updateFilterParams({ key: 'categoryFilter', value: '', fetchData: false })
            this.updateFilterParams({ key: 'frequencyFilter', value: '', fetchData: false })

            // Input değerlerini sıfırla
            this.searchQuery = ''
            this.categoryFilterInput = ''

            // Timeout'ları temizle
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            if (this.categorySearchTimeout) {
                clearTimeout(this.categorySearchTimeout)
            }

            // Diğer filtre ve dropdown state'lerini sıfırla
            this.showCategoryFilterOptions = false
            this.showFrequencyFilterOptions = false
        },
        // Sayfa ilk yüklendiğinde veya gerektiğinde çağrılacak yardımcı metot
        pageLoad() {
            // Her yükleme işleminde sadece bir kez API çağrısı yap
            if (this.activeTab === 'summary') {
                this.getTransactionsSummary()
            } else if (this.activeTab === 'incomes') {
                this.updateFilterParams({ key: 'type', value: 'income', fetchData: false })
                this.getTransactions('income')
            } else if (this.activeTab === 'expenses') {
                this.updateFilterParams({ key: 'type', value: 'expense', fetchData: false })
                this.getTransactions('expense')
            }
        },
    },
    watch: {
        // Sütun görünürlüğü değiştiğinde localStorage'a kaydet
        date_range: {
            handler() {
                // date_range içindeki değerler boş ise işlem yapma
                if (!this.date_range.startDate || !this.date_range.endDate) {
                    return
                }

                // Bu değişkenler tanımlı değilse, güvenli şekilde kontrol et
                if (this.pagination && typeof this.getStats === 'function' && typeof this.getLocationStats === 'function') {
                    this.pagination.locationStats = {
                        page: 1,
                        dateRange: `${this.date_range.startDate},${this.date_range.endDate}`,
                    }
                    this.getStats(`${this.date_range.startDate},${this.date_range.endDate}`).then(({ data }) => {
                        if (this.chartBarData && this.chartDoughnutData) {
                            this.chartBarData.labels = data.chart.map((item) => {
                                const date = new Date(item.date)
                                const month = date.getMonth() + 1
                                const day = date.getDate()
                                const year = date.getFullYear()
                                return `${day}.${month}.${year}`
                            })
                            this.chartBarData.datasets[0].data = data.chart.map((item) => item.total_profit)
                            this.chartBarData.datasets[1].data = data.chart.map((item) => item.total_order_amount)
                            this.chartBarData.datasets[2].data = data.chart.map((item) => item.total_order_count)
                            this.chartBarKey += 1
                            this.chartDoughnutData.datasets[0].data = [data.ordersByStatus.pending, data.ordersByStatus.completed, data.ordersByStatus.canceled, data.ordersByStatus.refunded]
                            this.chartDoughnutKey += 1
                        }
                    })
                    this.getLocationStats({ payload: this.pagination.locationStats })
                }
            },
            deep: true,
        },
        columns: {
            handler(newValue) {
                localStorage.setItem('columns.transactions', JSON.stringify(newValue))
            },
            deep: true,
        },
        // Sayfa boyutu veya sayfa değiştiğinde verileri güncelle
        perPage() {
            this.currentPage = 1
            console.log('Per page changed to:', this.perPage)

            // Aktif tab'a göre uygun veri tipini çek
            this.fetchDataByActiveTab()
        },
        currentPage() {
            // Sayfa değiştiğinde aktif olan türe göre verileri getir
            console.log('Page changed to:', this.currentPage)

            // Aktif tab'a göre uygun veri tipini çek
            this.fetchDataByActiveTab()
        },
        // İşlemler değiştiğinde kategori listesini güncelle
        '$store.state.transactions.incomes.items'() {
            if (this.activeTab === 'incomes') {
                this.updateCategoriesFromTransactions('income')
            }
        },
        '$store.state.transactions.expenses.items'() {
            if (this.activeTab === 'expenses') {
                this.updateCategoriesFromTransactions('expense')
            }
        },
        frequencyFilter() {
            // Frequency değiştiğinde aktif olan türe göre verileri getir
            console.log('Frequency filter changed to:', this.frequencyFilter)

            // Aktif tab'a göre uygun veri tipini çek
            // if (this.activeTab === 'expenses') {
            //     this.getTransactions('expense')
            // }
        },
        // Kategori filtresi inputu değiştiğinde filtrelenmiş listeyi güncelle
        categoryFilterInput: {
            handler(newVal) {
                // Debounce uygula
                if (this.categorySearchTimeout) {
                    clearTimeout(this.categorySearchTimeout)
                }

                // Boş değilse 300ms sonra arama yap
                if (newVal) {
                    this.categorySearchTimeout = setTimeout(() => {
                        this.onCategoryFilterSearch()
                    }, 300)
                } else {
                    // Boşsa kategorileri temizle
                    this.filteredCategoryOptions = []
                }
            },
            immediate: true, // Sayfa yüklendiğinde watcher'ı tetikle
        },
        categoryFilter: {
            handler(newVal) {
                this.categoryFilterInput = newVal
            },
        },
        // Arama inputu değiştiğinde debounce uygula
        searchQuery: {
            handler(newVal) {
                // Debounce işlemi
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout)
                }

                // 500ms sonra arama yap
                // this.searchTimeout = setTimeout(() => {
                //     // Store'daki arama parametresini güncelle ve yeniden veri çek
                //     // this.updateFilterParams({ key: 'search', value: newVal }) // Bu satır gerekli değil çünkü zaten v-model ile bağlı
                //     // Aktif tab'a göre uygun veri tipini çek
                //     if (this.activeTab === 'incomes') {
                //         this.getTransactions('income')
                //     } else if (this.activeTab === 'expenses') {
                //         this.getTransactions('expense')
                //     } else {
                //         this.getTransactionsSummary()
                //     }
                //     console.log('Debounced search for:', newVal)
                // }, 500)
            },
        },
    },
}
</script>

<style lang="scss" scoped>
:root {
    --redesign-gray: #f8fafd;
    --redesign-primary: #ffb53e;
}
.dp__theme_light {
    --dp-primary-color: #ffb53e;
}
.store-tabs {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 5px;

    &__item {
        height: 53px;
        padding: 16px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        color: #132144;
        cursor: pointer;

        &:hover {
            background-color: #bdc5d133;
            color: #132144;
        }

        &.active {
            background-color: #bdc5d133;
            color: #132144;
        }

        .count-badge {
            padding: 3.67px 5.86px 3.67px 6.81px;
            border-radius: 800px;
            background-color: #677788;
            color: #fff;
            font-size: 10.5px;
            font-weight: 700;
            line-height: 12.71px;
            text-align: center;
        }
    }
}

body.is-sticky {
    .action-header {
        position: fixed;
        top: 30px;
        z-index: 5;
        width: calc(100% - 50px);

        > div {
            border-top: 1px solid #e7eaf3b2;
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    .custom-table-items {
        thead {
            box-shadow: 0px 60px 50px 0px #00203f40;
        }
    }
}

.action-header {
    & > div {
        display: block;
        background-color: var(--redesign-gray);
        margin-top: 10px;
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.94px;
        padding-left: 12px;
        padding-right: 12px;
        height: 69.79px;
    }
    &__btn {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
        height: 37px;
        padding-left: 10px;
        border-bottom: 0.6px solid #e7eaf3 !important;
        color: #677788 !important;
    }
}

.search-form {
    position: relative;
}

.dp__input_wrap {
    width: auto;
    > input {
        padding-inline-end: 12px !important;
        font-size: 14px;
        border: 0.6px solid #e7eaf3;
        color: #677788;
        width: 220px !important;
    }
}

.mr-8 {
    margin-right: 8px;
}

@media (width <= 767px) {
    .custom-table-items {
        overflow-x: auto !important;
    }
    .sm-flex-column {
        display: flex;
        flex-direction: column;
        justify-content: flex-start !important;
        align-items: baseline !important;
        gap: 0.5rem;
    }
    .action-header > div {
        height: auto !important;
    }
    .mr-8:last-child {
        margin-right: 0 !important;
    }
}

@media (width > 767px) {
    .custom-table-items {
        overflow-x: auto !important;
    }
}
</style>
